import axios from "axios";

const url = "https://api.elcoma.com.br/api";
const url_radius = "https://api-captive.wifi.sedu.es.gov.br/api";

export default class Db {
  constructor() {}

  //  async getTokenFake(){
        
    
  //       try {
  //         const response = await axios.get(url + '/clients/captiveToken');
  //         console.log(response);
  //         axios.defaults.headers.common["Authorization"] = response.data.data;
  //         return
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }

      getClientInfo(client){
        return axios.get(url + '/clients/findOne?filter={"where":{"controller_id":"' +
          client +
          '"},"fields":{'+
          '"id":1,'+
            '"lgpd_time":1,'+
            '"lgpd":1,'+
            '"bg_base64":1,'+
            '"welcomeFooter_en_US":1,'+
            '"welcomeFooter_pt_BR":1,'+
            '"welcomeHeader_en_US":1,'+
            '"welcomeHeader_pt_BR":1,'+
            '"withFacebook":1,'+
            '"auth_user_field":1,'+
            '"logo_base64":1,'+
            '"backgroundColor":1,'+
            '"textColor":1,'+
            '"externalApi":1,'+
            '"zone":1,'+
            '"detectUser":1,'+
            '"controller_id":1,'+
            '"primaryColor":1,'+
            '"secondaryColor":1,'+
            '"fields":1,'+
            '"url":1,'+
            '"api_settings":1,'+
            '"termsOfUse":1,'+
            '"termsOfUseEnglish":1,'+
            '"authApi":1}}'
        )
    
      }

  saveConnection(connection) {
    connection["datetime"] = Math.floor((new Date()).getTime() / 1000)

    return axios.post(url + '/connections', connection)
  }

  updateConnection(connection) {
    return axios.patch(url + '/connections/' + connection.id, connection)
  }

  getUserAuthByCpf(cpf) {
    return axios.get(url + '/userAuths/findOne?filter={"where": { "cpf": "' + cpf + '"}}')
  }

  getUserAuthByMac(mac) {
    return axios.get(url + '/userAuths/' + mac)
  }

  getAnonUserAuthByMac(mac, client) {
    return axios.get(url + "/userAuths/findByMac/" +client+ "/" +mac);
  }
  
  insertUserAuth(user) {
    return axios.post(url + '/userAuths', user)
  }

  updateUserAuth(user) {
    return axios.put(url + '/userAuths/' + user.mac, user)
  }

  getQuestionsByControllerId(controller_id) {
    return axios.get(url + '/questions?filter={"where": { "company_id": "' + controller_id + '", "is_active": true}}')
  }

  getVideosByControllerId(controller_id) {
    return axios.get(url + '/videoManifests?filter={"where": { "client_id": "' + controller_id + '"}}')
  }

  getVideosDates(company_id) {
    var now = (new Date()).toISOString();

    return axios.get(url + '/videoManifests?filter={ "where" : { "is_active": true, "client_id" : "' + company_id + '", "start_date": {"lte": "' + now + '"}, "end_date": {"gte":"' + now + '"}}}');
  }

  updateManifest(video) {
    return axios.put(url + '/videoManifests/' + video.id, video);
  }

  authExternalApi(client_id, mac, userAuth) {
    return axios.post(
      url + 
      '/smsS/authApi' +
      client_id +
      "/"+
      mac,
      userAuth
    );
  }

  sendDataExternalApi(body) {
    return axios.post(url + '/clients/api_data', body);
  }

  logNotification(client, message, title){
    var now = (new Date()).toISOString();
    var body ={
      "controller_id":client, 
      "titulo":title,
      "mensagem":message,
      "priority":1,
      "datetime":now
    }
    return axios.post(url+'/notificacaos', body)

  }

  getAvailableCampaign(client, mac) {
    return axios.get(
      url + "/videoManifests/getAvailableCampaign/" + client + "/" + mac
    );
  }
  
  // getVideosSegmentados(company_id, gender, birth_date) {
  //   var dateParts = birth_date.split("/");
  //   var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  //   var ageDifMs = Date.now() - dateObject;
  //   var ageDate = new Date(ageDifMs); // miliseconds from epoch
  //   var age = Math.abs(ageDate.getUTCFullYear() - 1970);
  //   var now = (new Date()).toISOString();

  //   var p1 = new Promise(resolve => {
  //     var saida = [];
  //     axios.get(url + '/videoManifests?filter={ "where" : { "is_active": true, "client_id" : "' + company_id + '", "start_date": {"lte": "' + now + '"}, "end_date": {"gte":"' + now + '"}}}').then(response => {
  //       response.data.forEach(el => {
  //         var matchGender = true;
  //         var matchAge = true;

  //         if (el.targetAges && age) {
  //           if (el.targetAges.ages) {
  //             if (age >= el.targetAges.ages[0] && age <= el.targetAges.ages[1]) {
  //               matchAge = true
  //             } else {
  //               matchAge = false;
  //             }
  //           }
  //         }

  //         if (el.targetSexes && gender) {
  //           el.targetSexes.forEach(tsex => {
  //             if (tsex.value == gender) {
  //               matchGender = tsex.is_active
  //             }
  //           })
  //         }

  //         if (matchAge && matchGender) saida.push(el);
  //       });

  //       resolve(saida);
  //     })
  //   });

  //   return p1;
  // }
  deleteUserAuth(mac) {
    return axios.delete(url + '/userAuths/' + mac)
  }
  deleteUserAuthByCpf(cpf) {
    return new Promise(function (resolve) {
      axios.get(url + '/userAuths?filter={"where": { "cpf": "' + cpf + '"},"fields":["mac"]}').then(function (response) {
        var usersCount = response.data.length
        var deletedCount = 0;
        response.data.forEach(function (el) {
          axios.delete(url + '/userAuths/' + el.mac).then(function () {

            usersCount--;
            deletedCount++;

            if (usersCount == 0) resolve({
              success: true,
              data: {
                deleted: deletedCount
              }
            });
          })
        })
      })
    })
  }

  sendDataExtApi(client_id, mac, connection_id) {
    return axios.post(url + '/clients/api_data3/' + mac + '/' + client_id + '/' + connection_id);
  }
  getRadcheck(username) {
    return axios.get(url_radius+"/radchecks/getradcheck/" + username.toLowerCase());
  }

  postRadcheck(user) {
    if (user.username) {
      user.username = user.username.toLowerCase();
    }
    return axios.post(url_radius+"/radchecks/postradcheck", user);
  }



}



// WEBPACK FOOTER //
// ./src/db.js